import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../../service/http/http.service';

export interface RestrictionSummary {
  id: string;
  _id: string;
  description: string;
  isActivate: boolean;
  active: string;
  category: string;
  type: string;
  class: string;
  restriction: string;
  origin: string;
  additionalInfo: string;
  status: string;
  dataModel: {
    name: string;
    id: string;
  } | null;
  approvers?:string[];
  approvedAt: string;
  approvalFailed?: boolean;
  approvedBy?: { name: string; email: string };
}

@Injectable({
  providedIn: 'root'
})
export class ResumoRestricaoService {
  constructor(private readonly http: HttpService) {}

  approveRestrictionAutomatically(restrictionId: string): Observable<unknown> {
    return this.http.genericPostBody(`restrictions/${restrictionId}/approve`, {});
  }

  fetchSummary(restrictionId: string): Observable<RestrictionSummary> {
    return this.http.genericGetWithId<RestrictionSummary>('restrictions', restrictionId);
  }

  approveRestrictionTokenEmail(token: string): Observable<unknown> {
    return this.http.genericPostBody(`restrictions/approve-by-token?token=${token}`, {});
  }
}


